import React from 'react';
import { SpotlightTarget } from '@atlaskit/onboarding';
import { useIntl } from '@atlassian/jira-intl';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { getCollectionsPageUrl } from '@atlassian/jira-polaris-component-collections/src/common/utils/collections.tsx';
import { useIsCrossProjectViewsEnabled } from '@atlassian/jira-polaris-lib-entitlement-utils/src/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { ROADMAP_INTRODUCTION_SPOTLIGHT } from '@atlassian/jira-polaris-lib-onboarding-flows/src/controllers/constants.tsx';
import { RoadmapIntroductionSpotlight } from '@atlassian/jira-polaris-lib-onboarding-flows/src/ui/collections/tour/roadmap-introduction-spotlight/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { OnboardingFlowsContainer } from '@atlassian/jira-polaris-lib-onboarding-flows/src/controllers/index.tsx';
import { NAVIGATION_ITEM_ID } from '../../common/constants.tsx';
import { TopLevelErrorBoundary } from '../../common/ui/error-boundary/index.tsx';
import { MenuTrigger } from '../../common/ui/menu/trigger/main.tsx';
import messages from './messages.tsx';

export const useShowRoadmaps = () => {
	const { appPermissions } = useTenantContext();
	const isRoadmapsEnabled = useIsCrossProjectViewsEnabled();
	return appPermissions.hasProductDiscoveryAccess && isRoadmapsEnabled;
};

export const RoadmapsButton = () => {
	const { formatMessage } = useIntl();
	const { isSiteAdmin } = useTenantContext();
	const accountId = useAccountId();
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const isJpdProjectView = window?.location.pathname.includes('/jira/polaris/projects');

	const menuTrigger = (
		<MenuTrigger
			href={getCollectionsPageUrl()}
			menuId={MENU_ID.ROADMAPS}
			navigationItemId={NAVIGATION_ITEM_ID.ROADMAPS}
			analyticsAttributes={{
				isSiteAdmin,
			}}
		>
			{formatMessage(messages.titleJpdRoadmaps)}
		</MenuTrigger>
	);

	if (!isJpdProjectView || !fg('polaris_roadmaps_introduction_spotlight')) {
		return menuTrigger;
	}

	return (
		<OnboardingFlowsContainer accountId={accountId}>
			<SpotlightTarget name={ROADMAP_INTRODUCTION_SPOTLIGHT}>
				{menuTrigger}
				{isJpdProjectView && fg('polaris_roadmaps_introduction_spotlight') && (
					<RoadmapIntroductionSpotlight
						collectionsUrl={getCollectionsPageUrl()}
						placement="bottom center"
					/>
				)}
			</SpotlightTarget>
		</OnboardingFlowsContainer>
	);
};

export const Roadmaps = () => (
	<TopLevelErrorBoundary id={MENU_ID.ROADMAPS}>
		<RoadmapsButton />
	</TopLevelErrorBoundary>
);
